// components/Footer.js
import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <p className="footer__brand">© 2025 KriyaDB</p>
        <nav className="footer__nav">
          <a href="#privacy">Privacy Policy</a>
          <a href="#terms">Terms of Service</a>
          <a href="mailto:ram@kriyadb.com">Contact</a>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
